/**
 * Investments API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { InvestmentProgram } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const investmentsApi = {
  programs: {
    list: async () => {
      return router.get<InvestmentProgram[]>('/investors/programs');
    },
    get: async (id: string) => {
      return router.get<InvestmentProgram>(`/investors/programs/${id}`);
    },
    submit: async (programId: string, investmentData: { amount: number; investmentDate: string; notes?: string }) => {
      const context = getContext();
      return router.post<{ success: boolean }>(`/investors/programs/${programId}/submit`, investmentData, context);
    }
  }
};

